import { StyleSheet, Dimensions } from 'react-native';

const screenWidth = Dimensions.get('window').width;

export const styles = StyleSheet.create({
    page: {
        flex: 1,
        marginTop: 20,
    },

    title: {
        fontSize: 48,
        color: '#FFC646',
        fontFamily: 'Montserrat',
        fontWeight: '700'
    },

    subTitle: {
        fontSize: 18,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        marginTop: 8
    },

    orange: {
        color: '#FFC646',
    },

    image: {
        height: 544,
        borderRadius: 23,
    },

    imageSquare: {
        //width: screenWidth * 0.9,
        height: screenWidth * 0.9,
        borderRadius: 23,
    },

    imageBubble: {
        position: 'absolute',
        backgroundColor: '#FFC646',
        paddingHorizontal: 18,
        paddingVertical: 12,
        borderRadius: 30,
        top: 75,
        right: 34
    },

    imageBubbleRight: {
        position: 'absolute',
        backgroundColor: '#FFC646',
        paddingHorizontal: 18,
        paddingVertical: 12,
        borderRadius: 30,
        bottom: 31,
        left: 32
    },

    projectName: {
        backgroundColor: 'rgb(255, 198, 70)',
        paddingHorizontal: 52,
        paddingVertical: 12,
        borderRadius: 25,
        display: 'flex',
        alignItems: 'center'
    },

    projectNameTop: {
        position: 'absolute',
        top: 16,
        left: 0,
        right: 0,
        margin: '5%'
    },

    projectNameLeft: {
        position: 'absolute',
        top: 32,
        left: 32,
    },

    projectNameLeftText: {
        fontSize: 24,
        color: 'rgb(83, 83, 83)'
    },

    hexagonLeft: {
        position: 'absolute',
        bottom: 32,
        left: 32
    },

    imageBubbleRightDown: {
        backgroundColor: '#615D8A',
        paddingHorizontal: 18,
        paddingVertical: 12,
        borderRadius: 30,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },

    imageBubbleRightViewCol: {
        position: 'absolute',
        flexDirection: 'column',
        top: 32,
        right: 32
    },

    imageBubbleLeftViewRow: {
        position: 'absolute',
        alignSelf: 'center',
        flexDirection: 'row',
        justifyContent: 'space-around',
        top: 128,
        width: '100%',
    },

    imageBubbleTextWhite: {
        fontSize: 20,
        color: 'white',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        textAlign: 'center'
    },

    imageBubbleText: {
        fontSize: 20,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
    },

    hexagons: {
        position: 'absolute',
        flexDirection: 'row',
        bottom: -65,
        width: '100%'
    },

    hexagon: {
        flex: 1,
        alignContent: 'center',
        alignItems: 'center'
    }
});